const apiUrl = process.env.REACT_APP_API_URL;

function getBasicAuthHeader() {
  const username = process.env.REACT_APP_API_USERNAME;
  const password = process.env.REACT_APP_API_PASSWORD;
  const encodedCredentials = btoa(`${username}:${password}`);
  return `Basic ${encodedCredentials}`;
}

/**
 * Parses a non-OK activation-code response into a user-facing error string.
 */
export async function readActivationCodeError(response) {
  try {
    const text = await response.text();
    if (!text) {
      return `Request failed: ${response.status}`;
    }
    try {
      const json = JSON.parse(text);
      if (typeof json === 'string') {
        return json;
      }
      if (json && typeof json.message === 'string') {
        return json.message;
      }
    } catch {
      return text;
    }
    return text;
  } catch {
    return `Request failed: ${response.status}`;
  }
}

/**
 * Preview an instructor activation code without redeeming.
 */
export async function previewInstructorActivationCode(code) {
  const response = await fetch(`${apiUrl}/api/instructor/activation-code/preview`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: '*/*',
      Authorization: getBasicAuthHeader(),
    },
    body: JSON.stringify({ code }),
  });
  if (!response.ok) {
    throw new Error(await readActivationCodeError(response));
  }
  return response.json();
}

/**
 * Redeem an instructor activation code and return grant metadata + entitlements.
 */
export async function redeemInstructorActivationCode(userId, code, isYearly) {
  const response = await fetch(`${apiUrl}/api/instructor/activation-code/redeem/${userId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: '*/*',
      Authorization: getBasicAuthHeader(),
    },
    body: JSON.stringify({ code, isYearly }),
  });
  if (!response.ok) {
    throw new Error(await readActivationCodeError(response));
  }
  return response.json();
}
